var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.darkmode = !_vm.darkmode}}},[(_vm.darkmode)?_c('v-icon',[_vm._v("mdi-brightness-6")]):_c('v-icon',[_vm._v("mdi-brightness-2")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }